/**
 * `/zadania/rodzaje` — which kinds of task reach the trainer's queue (R16 to R19).
 *
 * A STATIC segment under `/zadania`, and a screen. The setting is stored per user and shared with
 * the phone; the web had no surface for it until now, which is why the Pulpit's muted sentence used
 * to say "ustawisz w aplikacji mobilnej".
 */

import { createFileRoute } from '@tanstack/react-router';

import { TaskKindsScreen } from '~/pages/tasks';

export const Route = createFileRoute('/_shell/zadania/rodzaje')({
  component: TaskKindsScreen,
});
